module.exports = __webpack_public_path__ + "media/images/cplook/android-chrome-36x36-7c9aa690e9cce1d036c749a93d27d540.png";